import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import { useQuery, useQueryClient } from '@tanstack/react-query';
import API_URL from './api/config';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footerbar from './components/Footerbar';
import useAppLayout from './hooks/useAppLayout';


function SignupCategory() {

   const { isSidebarVisible, showSidebar, toggleSidebar } = useAppLayout();

    const navigate = useNavigate();
     
      const [femaleCategory, setFemaleCategory] = useState("");

      const [isSubmitting, setIsSubmitting] = useState(false);


      const handleGoBack = () => {
        setIsSubmitting(true);
      
        axios.post(
          `${API_URL}/cancel-user-gender-api`,
          {},  
          { withCredentials: true }
        )
          .then(() => {
            toast.success("Gender cancelled successfully");
            navigate('/family-info-update');
          })
          .catch(() => {
            toast.error("Failed to cancel gender");
          })
          .finally(() => setIsSubmitting(false));
      };


      

      const handleCategorySubmit = async () => {
        if (!femaleCategory) {
          toast.warn("Please select a category");
          return;
        }
      
        if (isSubmitting) return; //  prevent double click
      
        setIsSubmitting(true);
      
        try {
          const res = await axios.post(
            `${API_URL}/reg-signup-category-update-api`,
            { female_category: femaleCategory },
            { withCredentials: true }
          );
      
          if (res.data.Status === "Success") {
            navigate(res.data.redirect);
          } else {
            toast.error("Failed to update Category.");
          }
        } catch (error) {
          console.error("Category update failed:", error);
          toast.error("Something went wrong.");
        } finally {
          setIsSubmitting(false); //  reset
        }
      };

       

      const OPTIONS = [
        {
          value: "Married",
          label: "Married",
          hint: "Currently married",
          icon: (
            <path d="M12 21c-4.4-2.7-8-6.2-8-10a4.8 4.8 0 0 1 8-3.6A4.8 4.8 0 0 1 20 11c0 3.8-3.6 7.3-8 10z" />
          ),
        },
        {
          value: "Single",
          label: "Single",
          hint: "Not currently married",
          icon: <circle cx="12" cy="8" r="4" />,
        },
        {
          value: "Single-Mother",
          label: "Single mother",
          hint: "Single, with children",
          icon: (
            <>
              <circle cx="9" cy="7" r="3" />
              <circle cx="17" cy="15" r="2.4" />
            </>
          ),
        },
      ];

      
      
    return (
    

        <div className="scrollPageContainer theme-light">
                    <div className="main-wrapper">
                        {isSidebarVisible && <Sidebar />}
                        <Header toggleSidebar={toggleSidebar} />
                        <Sidebar show={showSidebar} toggle={toggleSidebar} />
                        <Footerbar toggleSidebar={toggleSidebar} />
        
                         <ToastContainer />
        
    
        <div className="page-wrapper pb-0 d-flex justify-content-center">
        <div className="content container-fluid">
           

          <div className="row justify-content-center">
            <div className="col-12 col-lg-8 col-xl-7">
              {/* ✅ remove overflow-hidden (it can clip dropdowns) */}
              

              <div
        className="rounded-4 border-0"
        style={{
          background: "#ffffff",
          boxShadow: "0 2px 18px rgba(13,110,40,0.08)",
        }}
      >
        {/* Header */}
        <div
          className="px-4 py-3 rounded-top-4"
          style={{
            background: "#184A2C",
          }}
        >
          <p className="mb-0 fw-semibold" style={{ color: "#ffffff", fontSize: 15 }}>
            Choose the option that best represents your current status
          </p>
        </div>
 
        {/* Body */}
        <div className="p-3 p-md-4" style={{ paddingBottom: 28 }}>
          <div className="d-flex flex-column gap-2">
            {OPTIONS.map((opt) => {
              const selected = femaleCategory === opt.value;
              return (
                <label
                  key={opt.value}
                  htmlFor={opt.value}
                  className="d-flex align-items-center gap-3 rounded-3"
                  style={{
                    cursor: "pointer",
                    padding: "12px 16px",
                    border: selected ? "1.5px solid #184A2C" : "1.5px solid #e3e8e4",
                    background: selected ? "rgba(117,180,55,0.10)" : "#ffffff",
                    transition: "all 0.15s ease",
                  }}
                >
                  <input
                    type="radio"
                    name="female_category"
                    id={opt.value}
                    value={opt.value}
                    checked={selected}
                    onChange={(e) => setFemaleCategory(e.target.value)}
                    className="d-none"
                  />
 
                  {/* Icon bubble */}
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                    style={{
                      width: 40,
                      height: 40,
                      background: selected ? "#184A2C" : "#f2f5f2",
                      transition: "background 0.15s ease",
                    }}
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke={selected ? "#ffffff" : "#75B437"}
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      {opt.icon}
                    </svg>
                  </div>
 
                  {/* Text */}
                  <div className="flex-grow-1">
                    <div
                      className="fw-semibold"
                      style={{ fontSize: 15, color: selected ? "#184A2C" : "#212529" }}
                    >
                      {opt.label}
                    </div>
                    <div style={{ fontSize: 12.5, color: "#7a827c" }}>{opt.hint}</div>
                  </div>
 
                  {/* Custom check circle */}
                  <div
                    className="rounded-circle flex-shrink-0"
                    style={{
                      width: 20,
                      height: 20,
                      border: selected ? "none" : "1.5px solid #cfd6d1",
                      background: selected ? "#75B437" : "transparent",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {selected && (
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M5 13l4 4L19 7"
                          stroke="#ffffff"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    )}
                  </div>
                </label>
              );
            })}
          </div>
 
          {/* Action */}
          <div className="d-flex justify-content-end mt-4">
            <button
              onClick={handleCategorySubmit}
              className="btn rounded-3 px-4 py-2 d-inline-flex align-items-center justify-content-center fw-medium"
              disabled={isSubmitting || !femaleCategory}
              style={{
                minWidth: 130,
                background: !femaleCategory ? "#b9d7a1" : "#184A2C",
                border: "none",
                color: "#fff",
                transition: "background 0.15s ease",
              }}
              onMouseEnter={(e) => {
                if (femaleCategory) e.currentTarget.style.background = "#75B437";
              }}
              onMouseLeave={(e) => {
                if (femaleCategory) e.currentTarget.style.background = "#184A2C";
              }}
            >
              {isSubmitting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  />
                  Updating...
                </>
              ) : (
                <>Next &raquo;</>
              )}
            </button>
          </div>
        </div>
      </div>








              <div style={{ height: 8 }} />
            </div>
          </div>

          </div>
        </div>
      </div>
    </div>
    );
}

export default SignupCategory;
